import NodeAPI from '../api';
function toBytes(base64) {
  const pad = '='.repeat((4 - base64.length % 4) % 4);
  const binary = atob((base64 + pad).replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from(binary, c => c.charCodeAt(0));
}
export function pushSupported() {
  return window.isSecureContext && 'serviceWorker' in navigator &&
    'PushManager' in window && 'Notification' in window;
}
export async function subscribeDevice({ requestPermission = true } = {}) {
  if (!pushSupported()) throw new Error('Push notifications are unavailable in this browser or context.');
  if (Notification.permission === 'denied') throw new Error('Notifications are blocked. Change browser or system settings to enable them.');
  const permission = Notification.permission === 'default' && requestPermission
    ? await Notification.requestPermission() : Notification.permission;
  if (permission !== 'granted') throw new Error('Notification permission was not granted.');
  const registration = await navigator.serviceWorker.ready;
  const { data } = await NodeAPI.get('/quiz/notifications/public-key');
  const existing = await registration.pushManager.getSubscription();
  const subscription = existing || await registration.pushManager.subscribe({
    userVisibleOnly: true, applicationServerKey: toBytes(data.publicKey)
  });
  try {
    await NodeAPI.post('/quiz/notifications/subscriptions', subscription.toJSON());
  } catch (error) {
    if (!existing) await subscription.unsubscribe();
    throw error;
  }
  localStorage.removeItem('quizPushDeviceDisabled');
  return subscription;
}
export async function unsubscribeDevice() {
  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();
  if (!subscription) return;
  await NodeAPI.delete('/quiz/notifications/subscriptions', { data: { endpoint: subscription.endpoint } });
  await subscription.unsubscribe();
  localStorage.setItem('quizPushDeviceDisabled', '1');
}
